import { render, staticRenderFns } from "./RemarkUntreated.vue?vue&type=template&id=887eaa2e&scoped=true&"
import script from "./RemarkUntreated.vue?vue&type=script&lang=js&"
export * from "./RemarkUntreated.vue?vue&type=script&lang=js&"
import style0 from "./RemarkUntreated.vue?vue&type=style&index=0&id=887eaa2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887eaa2e",
  null
  
)

export default component.exports